export default __webpack_public_path__ + "static/media/way_0.ba8ef952.jpg";